import { NgModule } from '@angular/core';

import { F3DatePipe } from './f3-date.pipe';

@NgModule({
  declarations:[F3DatePipe], 
  imports:[ ],
  exports:[F3DatePipe] 
})

export class CustomPipesModule{}